import { ITheme } from "../../utils/theme"

export const ModalStyle = (theme: ITheme) => ({
  background: 'transparent',
  overflow: 'auto',
  top: '74px',
})

export const ModalBackdropStyle = {
  backgroundColor: 'transparent',
  outline: 'none',
}

export const GridContainerStyle = {
  justifyContent: 'center',
  outline: 'none'
}

export const CloseIconWrapperStyle = {
  textAlign: 'end',
  background: (theme: ITheme) => theme.palette.warning.light,
  borderRadius: 1,
  boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
  '&.High': {
    background: (theme: ITheme) => theme.palette.red[350],
  },
  '&.Normal': {
    background: (theme: ITheme) => theme.palette.yellow[600],
  },
  '&.Low': {
    background: (theme: ITheme) => theme.palette.oceanicGreen,
  },
}

export const CloseIconStyle = {
  fill: (theme: ITheme) => theme.palette.grey[400],
  position: 'relative',
  top: '15px',
  right: '16px',
  cursor: 'pointer',
}